import { render, staticRenderFns } from "./FormTitle.vue?vue&type=template&id=4732db3b&scoped=true&"
import script from "./FormTitle.vue?vue&type=script&lang=js&"
export * from "./FormTitle.vue?vue&type=script&lang=js&"
import style0 from "./FormTitle.vue?vue&type=style&index=0&id=4732db3b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4732db3b",
  null
  
)

export default component.exports